// extracted by mini-css-extract-plugin
export default {"chips":"CdmFinderCells_chips__2PpbW"};